// extracted by mini-css-extract-plugin
module.exports = {"scripts":"scripts--6om3U"};